<div class="auth-page">
  <div class="auth-page__content">
    <header class="auth-page__header">
      <app-secondary-logo />
    </header>
    <div class="auth-page__form-wrapper">
      <div class="auth-page__form">
        <h3 class="auth-page__title heading-lg">
          {{ 'authenticatorPage.title' | translate }}
        </h3>
        <p class="auth-page__subtitle option">
          {{ 'authenticatorPage.subtitle' | translate }}
        </p>
        <p class="auth-page__instruction strong-1">
          {{ 'authenticatorPage.instruction' | translate }}
        </p>
        @if (isTotpInvalid()) {
          <p class="auth-page__error-message">
            {{ 'authenticatorPage.invalidTotp' | translate }}
          </p>
        }
        <form [formGroup]="totpForm" (ngSubmit)="onSubmit()">
          <div class="auth-page__input-fields" formArrayName="code">
            @for (ctrl of codeArray.controls; let i = $index; track i) {
              <input
                type="text"
                class="auth-page__digit-input"
                mask="0"
                [class.invalid]="(ctrl.invalid && (ctrl.dirty || ctrl.touched)) || isTotpInvalid()"
                [formControlName]="i"
                (input)="onDigitInput($event, i)"
                (keydown)="onKeyDown($event, i)"
                (paste)="onPaste($event)"
              />
            }
          </div>
          <button
            type="submit"
            [disabled]="totpForm.invalid || loading()"
            class="auth-page__button option secondary-button"
            [ngClass]="{ disabled: totpForm.invalid || loading() }"
          >
            {{ 'authenticatorPage.continueButton' | translate }}
          </button>
        </form>
      </div>
    </div>
  </div>
  <div class="auth-page__banner">
    <div class="auth-page__banner-content">
      <img src="assets/images/auth-banner.png" alt="auth-banner" />
    </div>
  </div>
</div>
